import Axios from "axios";
import { useEffect, useState } from "react";
import { Box, IconButton } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";

const Sales = () => {

  const [mappedData, setMappedData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch both sales and products simultaneously
        const [salesRes, productsRes] = await Promise.all([
          Axios.get("https://store.petplanet.rw/api/sales"),
          Axios.get("https://store.petplanet.rw/api/products"),
        ]);

        const salesData = salesRes.data || [];
        const productsData = productsRes.data || [];

        // Map product name into sales
        const mapped = salesData.map((sale) => {
          const product = productsData.find(
            (p) => Number(p.id) === Number(sale.product_id)
          );
          return {
            id: sale.id, // Important for DataGrid
            ...sale,
            product_name: product ? product.name : "Unknown",
          };
        });

        setMappedData(mapped);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const columns = [
    {
      field: "product_name",
      headerName: "Product Name",
      flex: 1,
    },
    {
      field: "selling_price",
      headerName: "Unit Price",
      type: "number",
      headerAlign: "left",
      align: "left",
      flex: 1,
      renderCell: (params) => {
        const value = parseFloat(params.value);
        const formattedValue = isNaN(value) ? "0" : value.toLocaleString(); // adds commas
        return (
         <Box display="flex" justifyContent="flex-start" alignItems="center">
            {formattedValue} <span style={{ color: tokens.blueAccent[300], fontWeight: "bold", marginLeft: "4px" }}>RWF</span>
          </Box>
        );
      }
    },
     {
      field: "quantity",
      headerName: "Quantity",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "total",
      headerName: "Total",
      type: "number",
      headerAlign: "left",
      align: "left",
      flex: 1,
      renderCell: (params) => {
        const value = parseFloat(params.value);
        const formattedValue = isNaN(value) ? "0" : value.toLocaleString(); // adds commas
        return (
          <Box display="flex" justifyContent="flex-start" alignItems="center">
            {formattedValue} <span style={{ color: "#fbc02d", fontWeight: "bold", marginLeft: "4px" }}>RWF</span>
          </Box>
        );
      }
    },
    {
      field: "sales_date",
      headerName: "Sales Date",
      headerAlign: "left",
      align: "left",
      flex: 1
    },
  ];
  return (
    <>
    <Box m="20px" mt="80px">
      <Header title="Sales" subtitle="1,000 Sales" />
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
           "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: tokens.grey[800],
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: tokens.grey[100],
          },
          "& .MuiCheckbox-root": {
                      border: "none",
                      color: `${tokens.redAccent[400]} !important`,
          },
          "& .MuiDataGrid-columnHeader.action-column--header": {
            background: "none",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            color: `${tokens.grey[900]} !important`,
            fontSize: "12px",
          },
          "& .MuiDataGrid-columnSeparator--resizable": {
            color: `${tokens.blueAccent[100]} !important`,
          }
        }}
      >
        <DataGrid 
            checkboxSelection rows={mappedData} 
            columns={columns}  
            slots={{ toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: true, // Ensures the filter search bar is shown
              },
            }}
            sx={{
              "& .MuiDataGrid-toolbarContainer": {
                    display: "flex",
                    justifyContent: "space-between",
                  },
                  // Styling for all buttons within the DataGrid
                  "& .MuiButton-root": {
                    padding: "8px 15px", // Adjust padding for all button
                    textTransform: "none", // Keep text in normal case
                  },
                  "& .MuiButton-text": {
                    color: tokens.blueAccent[400], // Text color for text buttons
                  },
            }}
         />
      </Box>
    </Box>
  </>
  
  );
};

export default Sales;
